import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import 'common/css/master.css';
import './questionPaper.css';



function SyllabusPatternTbl(props) {
    const { lstPattern, patternId, setPatternId } = props;

    const [lstPatterns, setLstPatterns] = useState([]);
    const [selPatternId, setSelPatternId] = useState(patternId);

    useEffect(() => {
        // console.log("SyllabusPatternTbl called lstSyllabus", lstPattern);
        setLstPatterns(lstPattern);
    }, [lstPattern]);

    useEffect(() => {
        // console.log("SyllabusPatternTbl called patternId", patternId);
        setSelPatternId(patternId);
    }, [patternId]);

    const selectPattern = async (pPatternId) => {
        // console.log("selectPattern called, pPatternId, ", pPatternId);
        await setPatternId(pPatternId);
        setSelPatternId(pPatternId);
    }

    const colgrp = <colgroup>
        <col width="60"></col>
        <col width="30"></col>
        <col width="25"></col>
        <col width="35"></col>
    </colgroup>

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-sm-12 col-centered padding-remove" >
                <table className='tableLayout1'>
                    {colgrp}
                    <thead>
                        <tr>
                            <th className='text-center'>Pattern</th>
                            <th className='text-center'>Max. Marks</th>
                            <th className='text-center'>Section</th>
                            <th className='text-center'>Pattern Date</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "30vh", minHeight:"150px" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="diaryMonthlyTeacherAllocationTable" >
                            {lstPatterns &&
                                lstPatterns.map((pattern, i) => (
                                    <tr key={pattern.patternId}
                                        onClick={() => selectPattern(pattern.patternId)}
                                        className={pattern.patternId === selPatternId ? "selected" : ''}>
                                        <td className="text-left">{pattern.pattern}</td>
                                        <td className="text-left">{pattern.maxMarks}</td>
                                        <td className="text-left">{pattern.noOfSections}</td>
                                        <td className="text-left">{pattern.approvalDttm}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default SyllabusPatternTbl;